import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataResponse } from '../../../../core/models/data-response';
import { ConfigService } from '../../../../core/services/config/config.service';
import { UtilityService } from '../../../../core/services/utility/utility.service';
import { PatientFamilyHistory } from '../../models/patient-family-history';

@Injectable({
  providedIn: 'root',
})
export class PatientFamilyHistoriesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientFamilyHistoryEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientFamilyHistory`;

  postPatientFamilyHistories(
    patientId: number,
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<DataResponse<PatientFamilyHistory[]>> {
    const searchParams = {
      pageNumber,
      pageSize,
    };
    return this.utilityService.postRequest<DataResponse<PatientFamilyHistory[]>>(
      `${this.patientFamilyHistoryEndpoint}?patientId=${patientId}`,
      searchParams,
      { rawResponse: true, applyDefaultTimeout: true }
    );
  }

  getAllPatientFamilyHistoriesByPatientId(patientId: number): Observable<PatientFamilyHistory[]> {
    const url = `${this.patientFamilyHistoryEndpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientFamilyHistory[]>(url);
  }

  postPrintEvent(patientId: number, ids: number[]): Observable<void> {
    const url = `${this.patientFamilyHistoryEndpoint}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, { ids }, { skipGlobalError: true });
  }
}
